import React, { createContext, useContext } from "react";

const defaultTheme = {
    colors: {
        primary: "#4f46e5",
        background: "#f9fafb",
        sidebarBg: "#1e293b",
        headerBg: "#334155",
        textLight: "#fff",
        textDark: "#111",
    },
};

const ThemeContext = createContext(defaultTheme);

export const ThemeProvider = ({ children, theme }) => {
    return (
        <ThemeContext.Provider value={theme || defaultTheme}>
            {children}
        </ThemeContext.Provider>
    );
};

export const useTheme = () => useContext(ThemeContext);
